/* tslint:disable */
/* eslint-disable */
export enum WorkConnectorLinkStatusEnum {
  Synced = 'synced',
  Conflict = 'conflict',
  Error = 'error',
  Unmatched = 'unmatched',
  DeletedInSource = 'deleted_in_source',
  Ignored = 'ignored'
}
